// About.jsx — Redesigned, clean, fully animated premium About Us page
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FaLinkedinIn, FaTwitter, FaEnvelope,
  FaUserShield, FaClock, FaRocket, FaHeadset, FaCogs,
  FaUsers, FaCode, FaDatabase, FaMobile, FaCloud, FaPaintBrush,
  FaChartLine, FaLightbulb, FaAward, FaShieldAlt, FaHandshake,
  FaCheckCircle, FaGlobe, FaEye, FaBullseye, FaInfinity
} from "react-icons/fa";
import WhyChooseUs from "./Whychoose";

const About = () => {
  // Statistics counter state
  const [stats, setStats] = useState({
    projects: 0,
    clients: 0,
    years: 0,
    solutions: 0,
  });
           
  // Simulated counter animation
  useEffect(() => {
    const finalStats = { projects: 100, clients: 70, years: 6, solutions: 4 };
    const duration = 1800; // 1.8 seconds
    const frameDuration = 20; // 20ms per frame
    const totalFrames = duration / frameDuration;
    let frame = 0;

    const timer = setInterval(() => {
      frame++;   
      const progress = frame / totalFrames;

      setStats({
        projects: Math.floor(progress * finalStats.projects),
        clients: Math.floor(progress * finalStats.clients),
        years: Math.floor(progress * finalStats.years),
        solutions: Math.floor(progress * finalStats.solutions),
      });

      if (frame === totalFrames) {
        clearInterval(timer);
        setStats(finalStats);
      }
    }, frameDuration);

    return () => clearInterval(timer);
  }, []);

  // Team data
  const leadership = [
    {
      id: 1,
      name: "Santosh Munde",
      role: "CEO & Founder",
      image: "/Team/sir.png",
      description: "Visionary leader with 10+ years in the IT industry, leading digital transformation.",
      social: {
        linkedin: "#",
        twitter: "#",
        email: "santosh@theinnovativesolutions.in",
      },
    },
  ];

  const technicalTeam = [
     {
      id: 2,
      name: "Harshal Deore",
      role: "Project Manager",
      image: "/Team/harshal1.png",
      skills: ["AWS", "Docker", "Kubernetes"],
      icon: FaCloud,
    },   
     {   
      id: 6,
      name: "Mrug Rajguru",
      role: "Human Resource",
      image: "/Team/mrug.jpeg",
      skills: ["Communication", "Analysis", "Management", "Leadership"],
      icon: FaCogs,      
    },
    {
      id: 1,
      name: "Shubham Kekane",
      role: "Software Engineer",
      image: "/Team/shubhamsir.jpeg",
      skills: ["MERN Stack", "Mobile Apps (APKs)", "Blockchain"],
      icon: FaDatabase,
    },
    {                 
      id: 3,
      name: "Chaitanya Sonaje",
      role: "Full Stack Developer",
      image: "/Team/chaita.png",
      skills: ["React Native", "Flutter", "iOS"],
      icon: FaMobile,
    },
     {                 
      id: 11,
      name: "Kunal Desale",
      role: "Graphic Designer",
      image: "/Team/kunal.png",
     skills: ["Photoshop", "Adobe", "Editing"],   
      icon: FaChartLine,
    },
   {
      id: 5,
      name: "Darshan Pawar",
      role: "Graphic Designer", 
      image: "/Team/darshan.png", 
      skills: ["Photoshop", "Adobe", "Editing"],   
      icon: FaChartLine,
    }, 
     {
      id: 8,
      name: "Dattatray Dhongade",
      role: "Fullstack Developer",
      image: "/Team/datta.jpeg",     
      skills: ["Photoshop", "Adobe", "Editing"],      
      icon: FaPaintBrush,           
    },

    {
      id: 4,
      name: "Tanamay Tambe",
      role: "FullStack Developer",
      image: "/Team/tanyaa.png",
      skills: ["Figma", "React.js", "Node.js"],
      icon: FaPaintBrush,
    },             
    {
      id: 7,
      name: "Sneha Tambe",
      role: "Data Analyst",
      image: "/Team/sneha1.jpeg",
      skills: ["MS Excel","Python", "Power BI"],   
      icon: FaCode, 
    },
    {
      id: 9,
      name: "Sanchita Boraste",
      role: "Data Analyst",
      image: "/Team/sanchita.png",
      skills: ["MS Excel","Python", "Power BI"],   
      icon: FaCode, 
    },
    {
      id: 10,
      name: "Shruti Ganore",
      role: "Data Analyst",
      image: "/Team/shruti.png",
      skills: ["MS Excel","Python", "Power BI"],   
      icon: FaCode, 
    },
 
  ];

  // Company highlights data
  const highlights = [
    {
      icon: FaRocket,
      title: "Innovation First",
      description: "Cutting-edge technology solutions",
      color: "#248ecb",
      bgHover: "linear-gradient(135deg, rgba(36,142,203,0.06) 0%, rgba(36,142,203,0.12) 100%)",
      glowColor: "rgba(36,142,203,0.25)"
    },
    {
      icon: FaShieldAlt,
      title: "Reliable & Secure",
      description: "Trusted by 40+ organizations",
      color: "#16a34a",
      bgHover: "linear-gradient(135deg, rgba(22,163,74,0.06) 0%, rgba(22,163,74,0.12) 100%)",
      glowColor: "rgba(22,163,74,0.25)"
    },
    {
      icon: FaHandshake,
      title: "Client Partnership",
      description: "Long-term business relationships",
      color: "#7c3aed",
      bgHover: "linear-gradient(135deg, rgba(124,58,237,0.06) 0%, rgba(124,58,237,0.12) 100%)",
      glowColor: "rgba(124,58,237,0.25)"
    },
    {
      icon: FaAward,
      title: "Quality Excellence",
      description: "Award-winning solutions",
      color: "#f97316",
      bgHover: "linear-gradient(135deg, rgba(249,115,22,0.06) 0%, rgba(249,115,22,0.12) 100%)",
      glowColor: "rgba(249,115,22,0.25)"
    },
  ];

  // Stats strip data
  const statsData = [
    { icon: FaCode, number: stats.projects, label: "Projects Completed", color: "#243e7c" },
    { icon: FaUsers, number: stats.clients, label: "Happy Clients", color: "#248ecb" },
    { icon: FaClock, number: stats.years, label: "Years Experience", color: "#16a34a" },
    { icon: FaRocket, number: stats.solutions, label: "Enterprise Solutions", color: "#f97316" }
  ];

  // Animations configuration
  const bannerAnim = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <div style={{
      fontFamily: "'Manrope', sans-serif",
      background: "#ffffff",
      overflowX: "hidden"
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Playfair+Display:ital,wght@0,700;1,400;1,700&family=Manrope:wght@300;400;500;600;700;800&display=swap');

        /* Hero Backdrop Grid Effect */
        .abt-hero-bg {
          background: linear-gradient(135deg, #0a1c3b 0%, #0f2d54 50%, #0a1c3b 100%);
          position: relative;
          overflow: hidden;
        }

        .abt-hero-grid {
          position: absolute;
          inset: 0;
          background-image: radial-gradient(rgba(255,255,255,0.035) 1px, transparent 1px);
          background-size: 28px 28px;
          pointer-events: none;
        }

        /* Redesigned Premium Glassmorphic Cards */
        .glass-highlight-card-redesigned {
          background: #ffffff;
          border: 1px solid rgba(36, 62, 124, 0.08);
          border-radius: 20px;
          padding: 1.5rem;
          box-shadow: 0 8px 30px rgba(36, 62, 124, 0.03);
          transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
          position: relative;
          overflow: hidden;
        }

        .glass-highlight-card-redesigned::before {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: 20px;
          padding: 2px;
          background: linear-gradient(135deg, transparent 40%, rgba(36, 62, 124, 0.1) 100%);
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          pointer-events: none;
        }

        .glass-highlight-card-redesigned:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px var(--hover-glow, rgba(36, 62, 124, 0.08));
          border-color: var(--theme-color, #248ecb);
          background: var(--bg-gradient-hover, #ffffff);
        }

        .glass-stats-card {
          background: rgba(255, 255, 255, 0.9);
          border: 1px solid rgba(36, 62, 124, 0.08);
          border-radius: 20px;
          padding: 2rem 1.5rem;
          box-shadow: 0 10px 30px rgba(36, 62, 124, 0.05);
          text-align: center;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .glass-stats-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(36, 62, 124, 0.12);
        }

        /* Asymmetric layered image collage layout */
        .abt-collage-container {
          position: relative;
          width: 100%;
          max-width: 480px;
          margin: 0 auto;
          aspect-ratio: 4 / 4.3;
        }

        .abt-collage-backdrop-glow {
          position: absolute;
          width: 130%;
          height: 130%;
          top: -15%;
          left: -15%;
          background: radial-gradient(circle, rgba(36, 142, 203, 0.12) 0%, transparent 65%);
          filter: blur(40px);
          pointer-events: none;
          z-index: 1;
        }

        .abt-collage-main-frame {
          position: absolute;
          width: 85%;
          height: 75%;
          top: 0;
          left: 0;
          border-radius: 32px;
          overflow: hidden;
          box-shadow: 0 25px 50px rgba(10, 28, 59, 0.15);
          border: 2px solid #ffffff;
          z-index: 3;
          transition: transform 0.4s ease;
        }

        .abt-collage-main-frame:hover {
          transform: scale(1.02) translateY(-4px);
        }

        .abt-collage-overlay-frame {
          position: absolute;
          width: 60%;
          height: 55%;
          bottom: 0;
          right: 0;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 20px 45px rgba(10, 28, 59, 0.22);
          border: 4px solid #ffffff;
          z-index: 4;
          transition: transform 0.4s ease;
        }

        .abt-collage-overlay-frame:hover {
          transform: scale(1.04) translateY(-6px);
        }

        .abt-experience-floating-pill {
          position: absolute;
          top: 48%;
          left: -20px;
          background: rgba(255, 255, 255, 0.96);
          backdrop-filter: blur(8px);
          border-radius: 50px;
          padding: 10px 24px;
          box-shadow: 0 15px 35px rgba(36, 62, 124, 0.12);
          border: 1px solid rgba(36, 62, 124, 0.08);
          z-index: 5;
          display: flex;
          align-items: center;
          gap: 12px;
          animation: floatOverlay 5s ease-in-out infinite;
        }

        @keyframes floatOverlay {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }

        /* Description text panel container */
        .abt-glass-story-panel {
          background: rgba(36, 62, 124, 0.02);
          border-left: 4px solid #243e7c;
          border-radius: 0 16px 16px 0;
          padding: 1.5rem 1.75rem;
          margin-bottom: 2rem;
          border-top: 1px solid rgba(36, 62, 124, 0.05);
          border-right: 1px solid rgba(36, 62, 124, 0.05);
          border-bottom: 1px solid rgba(36, 62, 124, 0.05);
        }

        /* Team cards styling */
        .premium-team-card {
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(36, 62, 124, 0.05);
          transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          border: 1px solid rgba(36, 62, 124, 0.06);
        }

        .premium-team-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(36, 62, 124, 0.12);
        }

        .abt-card-media-wrapper {
          position: relative;
          overflow: hidden;
          aspect-ratio: 4 / 5;
        }

        .abt-card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.4s ease;
        }

        .premium-team-card:hover .abt-card-img {
          transform: scale(1.08);
        }

        /* Sliding team details overlay */
        .abt-team-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(10,28,59,0.3) 0%, rgba(10,28,59,0.92) 100%);
          display: flex;
          align-items: flex-end;
          padding: 1.5rem;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .premium-team-card:hover .abt-team-overlay {
          opacity: 1;
        }

        .abt-social-btn {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          color: #ffffff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.25s;
          text-decoration: none;
        }

        .abt-social-btn:hover {
          background: #248ecb;
          color: #ffffff;
          transform: translateY(-2px);
        }

        /* Philosophy and Values styling */
        .philosophy-strip {
          background: linear-gradient(135deg, #f8fbff 0%, #e6f2ff 100%);
          position: relative;
        }

        .glass-philosophy-card {
          background: #ffffff;
          border-radius: 24px;
          border: 1px solid rgba(36, 62, 124, 0.08);
          box-shadow: 0 15px 35px rgba(36, 62, 124, 0.05);
          overflow: hidden;
          transition: all 0.3s;
        }

        .glass-philosophy-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 25px 45px rgba(36, 62, 124, 0.1);
        }

        .philosophy-header-blue {
          background: linear-gradient(135deg, #243e7c 0%, #248ecb 100%);
        }

        .philosophy-header-cyan {
          background: linear-gradient(135deg, #248ecb 0%, #39aecb 100%);
        }

        .icon-pulse-wrapper {
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }

        /* Core Values Icons */
        .core-val-icon-box {
          width: 66px;
          height: 66px;
          border-radius: 18px;
          background: rgba(36, 62, 124, 0.06);
          color: #243e7c;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 0.75rem;
          font-size: 1.6rem;
          transition: all 0.3s ease;
        }

        .core-val-icon-box:hover {
          transform: translateY(-4px) rotate(6deg);
          background: #243e7c;
          color: #ffffff;
          box-shadow: 0 10px 20px rgba(36,62,124,0.18);
        }
      `}</style>

      {/* ── Hero Banner Section ── */}
      <div className="abt-hero-bg py-5">
        <div className="abt-hero-grid" />
        <Container className="py-5 position-relative" style={{ zIndex: 2 }}>
          <div className="text-center text-white py-4">
            <motion.div
              variants={bannerAnim}
              initial="hidden"
              animate="visible"
            >
              <div className="badge bg-gradient px-4 py-2 mb-4 rounded-pill" style={{
                background: "rgba(36,142,203,0.18)",
                border: "1px solid rgba(36,142,203,0.3)"
              }}>
                <span style={{ color: "#7dd3fc", fontSize: "0.72rem", fontWeight: 800, letterSpacing: "3px" }}>
                  ABOUT OUR COMPANY
                </span>
              </div>

              <h1 className="display-4 fw-bold mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: "-1.5px", lineHeight: 1.15 }}>
                Innovative Solutions<br />
                <span style={{
                  fontFamily: "'Playfair Display', serif",
                  fontStyle: "italic",
                  background: "linear-gradient(135deg, #248ecb 0%, #39aecb 100%)",
                  WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                  backgroundClip: "text"
                }}>IT Services</span>
              </h1>

              <p className="lead mb-4 mx-auto" style={{ maxWidth: "600px", color: "rgba(255,255,255,0.65)" }}>
                Empowering businesses through cutting-edge technology and custom software platforms since 2020.
              </p>

              <div style={{ width: "80px", height: "4px", background: "linear-gradient(90deg, #248ecb, #39aecb)", borderRadius: "2px", margin: "0 auto 2.5rem" }} />
            </motion.div>
          </div>
        </Container>
      </div>

      {/* ── Core About Us Content Section (Redesigned completely) ── */}
      <div id="about-content" className="py-5">
        <Container className="py-5">
          <Row className="align-items-center g-5 mb-5">
            {/* Left Column: Asymmetrical collage style layout */}
            <Col lg={5}>
              <div className="abt-collage-container">
                <div className="abt-collage-backdrop-glow" />
                
                {/* Main larger image frame */}
                <div className="abt-collage-main-frame" style={{ width: "100%", height: "100%" }}>
                  <img
                    src="/images/abo.gif"
                    alt="Animated 3D tech showcase"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>

                {/* Floating Experience badge */}
                <div className="abt-experience-floating-pill" style={{ bottom: "20px", left: "20px", top: "auto" }}>
                  <div style={{
                    width: "36px", height: "36px", borderRadius: "50%",
                    background: "rgba(36,142,203,0.1)", color: "#248ecb",
                    display: "flex", alignItems: "center", justifyContent: "center"
                  }}>
                    <FaAward size={18} />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-0" style={{ color: "#0a1c3b", fontSize: "0.9rem" }}>{stats.years}+ Years</h5>
                    <small className="text-muted fw-bold" style={{ fontSize: "0.62rem", textTransform: "uppercase" }}>IT Leadership</small>
                  </div>
                </div>
              </div>
            </Col>

            {/* Right Column: Dynamic story content & redesigned highlight grid */}
            <Col lg={7}>
              <div className="ps-lg-4">
                <div className="badge bg-light px-3 py-2 mb-3 rounded-pill" style={{ border: "1px solid rgba(36,62,124,0.08)" }}>
                  <FaGlobe className="me-2 text-primary" />
                  <span style={{ color: "#243e7c", fontWeight: 800, fontSize: "0.7rem", letterSpacing: "1px" }}>ABOUT US</span>
                </div>

                <h2 className="display-5 fw-bold mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#0a1c3b", letterSpacing: "-1.5px", lineHeight: 1.15 }}>
                  Transforming Ideas Into{" "}
                  <span style={{
                    fontFamily: "'Playfair Display', serif",
                    fontStyle: "italic",
                    background: "linear-gradient(135deg, #243e7c, #248ecb)",
                    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                    backgroundClip: "text"
                  }}>Digital Reality</span>
                </h2>

                <div className="abt-glass-story-panel">
                  <p className="fw-semibold text-primary mb-2" style={{ fontSize: "1.02rem", lineHeight: 1.6 }}>
                    <FaLightbulb className="me-2" />
                    Welcome to Innovative Solutions IT Services, founded in 2020.
                  </p>
                  <p className="text-muted mb-0" style={{ fontSize: "0.9rem", lineHeight: 1.75 }}>
                    Our core focus is on designing and building custom enterprise applications that enable businesses to succeed and achieve operational growth. We are guided by strong moral values, business ethics, and standard architectures to help clients go the extra mile.
                  </p>
                </div>

                {/* Redesigned 2x2 Grid of Floating Cards */}
                <Row className="g-4">
                  {highlights.map((h, idx) => (
                    <Col sm={6} key={idx}>
                      <div
                        className="glass-highlight-card-redesigned h-100"
                        style={{
                          "--theme-color": h.color,
                          "--bg-gradient-hover": h.bgHover,
                          "--hover-glow": h.glowColor
                        }}
                      >
                        <div className="d-flex align-items-start gap-3">
                          <div style={{
                            width: "42px", height: "42px", borderRadius: "12px",
                            background: `${h.color}12`, color: h.color,
                            display: "flex", alignItems: "center", justifyContent: "center",
                            flexShrink: 0
                          }}>
                            <h.icon size={18} />
                          </div>
                          <div>
                            <h6 className="fw-bold mb-1" style={{ color: "#0a1c3b", fontSize: "0.95rem" }}>{h.title}</h6>
                            <p className="text-muted mb-0" style={{ fontSize: "0.8rem", lineHeight: 1.4 }}>{h.description}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>

          {/* ── Stats Strip Cards Section ── */}
          <Row className="g-4 py-5 mt-4">
            {statsData.map((stat, idx) => (
              <Col lg={3} md={6} key={idx}>
                <div className="glass-stats-card">
                  <div style={{
                    width: "70px", height: "70px", borderRadius: "20px",
                    background: `${stat.color}10`, color: stat.color,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    margin: "0 auto 1.25rem"
                  }}>
                    <stat.icon size={30} />
                  </div>
                  <h3 className="fw-bold mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#0a1c3b", fontSize: "2.2rem", letterSpacing: "-1px" }}>
                    {stat.number}+
                  </h3>
                  <p className="text-muted fw-semibold mb-0" style={{ fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    {stat.label}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* ── Team Section ── */}
      <div className="py-5 bg-light">
        <Container className="py-5">
          {/* Section Header */}
          <div className="text-center mb-5">
            <div className="badge bg-light px-3 py-2 mb-3 rounded-pill" style={{ border: "1px solid rgba(36,62,124,0.08)" }}>
              <FaUsers className="me-2 text-primary" />
              <span style={{ color: "#243e7c", fontWeight: 800, fontSize: "0.7rem", letterSpacing: "1px" }}>OUR TEAM</span>
            </div>
            <h2 className="display-6 fw-bold mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#0a1c3b" }}>
              Meet Our Expert Team
            </h2>
            <div style={{ width: "60px", height: "4px", background: "linear-gradient(90deg, #243e7c, #248ecb)", borderRadius: "2px", margin: "0 auto 1.25rem" }} />
            <p className="lead text-muted mx-auto" style={{ maxWidth: "580px", fontSize: "1rem" }}>
              Our talented team of engineers and professionals dedicated to delivering exceptional results.
            </p>
          </div>

          {/* 1. Leadership Section */}
          <div className="mb-5">
            <h4 className="fw-bold text-center mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#243e7c", letterSpacing: "1px", textTransform: "uppercase", fontSize: "0.95rem" }}>
              Leadership Team
            </h4>
            <Row className="justify-content-center">
              {leadership.map((member) => (
                <Col lg={4} md={6} key={member.id}>
                  <Card className="premium-team-card h-100 border-0 overflow-hidden bg-white">
                    <div className="abt-card-media-wrapper">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="abt-card-img"
                      />
                      <div className="abt-team-overlay">
                        <div className="w-100 text-white">
                          <FaUserShield className="fs-2 mb-2 text-info" />
                          <p className="mb-3 text-white-50" style={{ fontSize: "0.85rem", lineHeight: 1.5 }}>{member.description}</p>
                          <div className="d-flex gap-2">
                            <a href={member.social.linkedin} className="abt-social-btn"><FaLinkedinIn size={14} /></a>
                            <a href={member.social.twitter} className="abt-social-btn"><FaTwitter size={14} /></a>
                            <a href={`mailto:${member.social.email}`} className="abt-social-btn"><FaEnvelope size={14} /></a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Card.Body className="p-4 text-center">
                      <h5 className="fw-bold mb-1" style={{ color: "#0a1c3b", fontSize: "1.15rem" }}>{member.name}</h5>
                      <p className="text-primary fw-bold mb-0" style={{ fontSize: "0.82rem", textTransform: "uppercase", letterSpacing: "1px" }}>{member.role}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          {/* 2. Technical Team Section */}
          <div className="mt-5 pt-3">
            <h4 className="fw-bold text-center mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#243e7c", letterSpacing: "1px", textTransform: "uppercase", fontSize: "0.95rem" }}>
              Technical Team
            </h4>
            <Row className="g-4">
              {technicalTeam.map((member) => (
                <Col lg={3} md={6} key={member.id}>
                  <Card className="premium-team-card h-100 border-0 overflow-hidden bg-white">
                    <div className="abt-card-media-wrapper">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="abt-card-img"
                      />
                      <div className="abt-team-overlay">
                        <div className="w-100 text-white">
                          {/* <member.icon className="fs-2 mb-2 text-info" /> */}
                          {/* <div className="d-flex flex-wrap gap-1 mt-2">
                            {member.skills.map((skill, idx) => (
                              <span
                                key={idx}
                                className="badge bg-light text-dark"
                                style={{ fontSize: "0.62rem", fontWeight: 700 }}
                              >
                                {skill}
                              </span>
                            ))}
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <Card.Body className="p-4 text-center">
                      <h5 className="fw-bold mb-1" style={{ color: "#0a1c3b", fontSize: "1rem" }}>{member.name}</h5>
                      <p className="text-muted mb-0" style={{ fontSize: "0.82rem", fontWeight: 600 }}>{member.role}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </div>

      {/* ── Why choose us ── */}
      <WhyChooseUs />

      {/* ── Vision and Mission ── */}
      <div className="py-5 philosophy-strip">
        <Container className="py-5">
          {/* Section Header */}
          <div className="text-center mb-5">
            <div className="badge bg-light px-3 py-2 mb-3 rounded-pill" style={{ border: "1px solid rgba(36,62,124,0.08)" }}>
              <FaInfinity className="me-2 text-primary" />
              <span style={{ color: "#243e7c", fontWeight: 800, fontSize: "0.7rem", letterSpacing: "1px" }}>OUR PHILOSOPHY</span>
            </div>
            <h2 className="display-6 fw-bold mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#0a1c3b" }}>
              Vision & Mission
            </h2>
            <div style={{ width: "60px", height: "4px", background: "linear-gradient(90deg, #243e7c, #248ecb)", borderRadius: "2px", margin: "0 auto 1.25rem" }} />
            <p className="lead text-muted mx-auto" style={{ maxWidth: "580px", fontSize: "1rem" }}>
              Our guiding principles that inspire innovation and create lasting partnerships in the world of technology.
            </p>
          </div>

          <Row className="g-5">
            {/* Vision Card */}
            <Col lg={6}>
              <div className="glass-philosophy-card h-100">
                {/* Header block */}
                <div className="philosophy-header-blue p-5 text-center text-white relative">
                  <div className="icon-pulse-wrapper mb-3">
                    <FaEye size={24} className="text-white" />
                  </div>
                  <h3 className="fw-bold mb-0" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Our Vision</h3>
                </div>

                <div className="p-5">
                  <div className="d-flex align-items-center mb-3">
                    <FaRocket className="text-primary me-2 fs-5" />
                    <span className="fw-bold text-primary" style={{ fontSize: "0.95rem" }}>Leading Innovation</span>
                  </div>
                  <p className="text-muted mb-4 lh-lg" style={{ fontSize: "0.95rem" }}>
                    Our vision at Innovative Solutions IT Services is to be a <strong>trailblazing force</strong> in the IT industry, renowned for delivering game-changing solutions that transform businesses and drive growth.
                  </p>
                  <p className="text-muted lh-lg" style={{ fontSize: "0.95rem" }}>
                    We strive to become the <em>go-to partner</em> for organizations seeking innovative ideas and cutting-edge technologies to gain a competitive edge in their respective markets.
                  </p>

                  <div className="mt-4 pt-3 border-top d-flex align-items-center text-primary">
                    <FaGlobe className="me-2" />
                    <small className="fw-bold uppercase" style={{ fontSize: "0.68rem" }}>Transforming Businesses Globally</small>
                  </div>
                </div>
              </div>
            </Col>

            {/* Mission Card */}
            <Col lg={6}>
              <div className="glass-philosophy-card h-100">
                {/* Header block */}
                <div className="philosophy-header-cyan p-5 text-center text-white relative">
                  <div className="icon-pulse-wrapper mb-3">
                    <FaBullseye size={24} className="text-white" />
                  </div>
                  <h3 className="fw-bold mb-0" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Our Mission</h3>
                </div>

                <div className="p-5">
                  <div className="d-flex align-items-center mb-3">
                    <FaHandshake className="text-success me-2 fs-5" />
                    <span className="fw-bold text-success" style={{ fontSize: "0.95rem" }}>Empowering Success</span>
                  </div>
                  <p className="text-muted mb-4 lh-lg" style={{ fontSize: "0.95rem" }}>
                    Our mission is to <strong>empower businesses</strong> with customized and result-oriented IT solutions that foster efficiency, productivity, and sustainable growth.
                  </p>
                  <p className="text-muted lh-lg" style={{ fontSize: "0.95rem" }}>
                    We are committed to continuously expanding our domain and technical expertise to meet the evolving needs of our clients, building <em>lasting relationships</em> as trusted allies in their success stories.
                  </p>

                  <div className="mt-4 pt-3 border-top d-flex align-items-center text-success">
                    <FaHeadset className="me-2" />
                    <small className="fw-bold uppercase" style={{ fontSize: "0.68rem" }}>Customer-Centric Approach</small>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Core Values Section */}
          <div className="text-center mt-5 pt-5">
            <h4 className="fw-bold mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#0a1c3b" }}>
              <FaCheckCircle className="text-success me-2" />
              Our Core Values
            </h4>
            <Row className="justify-content-center">
              <Col md={8}>
                <div className="d-flex justify-content-center gap-4 align-items-center flex-wrap">
                  <div className="text-center m-2">
                    <div className="core-val-icon-box">
                      <FaShieldAlt />
                    </div>
                    <small className="fw-bold text-muted">Integrity</small>
                  </div>
                  <div className="text-center m-2">
                    <div className="core-val-icon-box">
                      <FaRocket />
                    </div>
                    <small className="fw-bold text-muted">Innovation</small>
                  </div>
                  <div className="text-center m-2">
                    <div className="core-val-icon-box">
                      <FaUsers />
                    </div>
                    <small className="fw-bold text-muted">Collaboration</small>
                  </div>
                  <div className="text-center m-2">
                    <div className="core-val-icon-box">
                      <FaAward />
                    </div>
                    <small className="fw-bold text-muted">Excellence</small>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default About;
